module.exports = __webpack_public_path__ + "static/media/03-weekend.5a32b8bf.png";